<div class="space-y-4">
  <div>
    <input
      type="text"
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearchChange()"
      placeholder="Rechercher un document"
      class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm placeholder:text-gray-300" />
  </div>

  <div
    class="grid gap-4"
    [ngClass]="activePreviewDocument ? 'lg:grid-cols-[320px_minmax(0,1fr)]' : 'lg:grid-cols-1'">
    <div class="max-h-[420px] space-y-3 overflow-y-auto pr-1">
      <div
        *ngFor="let doc of filteredDocuments"
        class="flex items-start justify-between gap-3 rounded-xl border border-gray-200 px-4 py-3 hover:bg-gray-50"
        [ngClass]="{
          'border-primary': activePreviewDocument === doc,
          'bg-primary/5': activePreviewDocument === doc
        }">
        <div class="flex min-w-0 items-start gap-3">
          <input
            type="checkbox"
            class="checkbox checkbox-sm mt-0.5"
            [checked]="isSelected(getDocumentId(doc))"
            (change)="toggleDocument(getDocumentId(doc))" />
          <div class="min-w-0">
            <p class="truncate text-sm font-medium text-gray-900">
              {{ doc.filename || 'Document sans nom' }}
            </p>
            <p class="mt-1 text-xs text-gray-500">
              {{ doc.documentType?.label || 'Type non renseigne' }}
            </p>
            <p class="mt-1 text-xs text-gray-400">
              {{ doc.createdAt ? (doc.createdAt | date:'dd/MM/yyyy à HH:mm') : 'Date non renseignee' }}
            </p>
          </div>
        </div>
        <button
          type="button"
          (click)="setActivePreviewDocument(doc)"
          class="rounded-md border border-gray-200 p-2 text-gray-600 transition hover:bg-white hover:text-gray-900"
          title="Previsualiser">
          <lucide-icon [img]="EyeIcon" [size]="16"></lucide-icon>
        </button>
      </div>
    </div>

    <div
      *ngIf="activePreviewDocument"
      class="min-h-[420px]">
      <div class="flex h-[420px] items-center justify-center">
        <div *ngIf="previewLoading" class="text-sm text-gray-500">
          Chargement de la previsualisation...
        </div>

        <img
          *ngIf="!previewLoading && activePreviewDocument && previewUrl && isPreviewableImage(activePreviewDocument.filename)"
          [src]="previewUrl"
          [alt]="activePreviewDocument.filename || 'Document'"
          class="max-h-full max-w-full rounded-lg object-contain shadow-sm" />

        <iframe
          *ngIf="!previewLoading && activePreviewDocument && safePreviewUrl && isPreviewablePdf(activePreviewDocument.filename)"
          [src]="safePreviewUrl"
          class="h-full w-full rounded-lg bg-white"
          title="Previsualisation PDF">
        </iframe>

        <div
          *ngIf="!previewLoading && activePreviewDocument && (!previewUrl || (!isPreviewableImage(activePreviewDocument.filename) && !isPreviewablePdf(activePreviewDocument.filename)))"
          class="text-center text-sm text-gray-500">
          <p>Ce type de fichier ne peut pas etre previsualise ici.</p>
          <p class="mt-2">Nom : {{ activePreviewDocument.filename || 'Document sans nom' }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="flex justify-end gap-3 border-t border-gray-200 pt-4">
    <button
      type="button"
      (click)="close()"
      class="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">
      Annuler
    </button>
    <button
      type="button"
      (click)="confirmSelection()"
      class="rounded-md bg-primary px-4 py-2 text-sm font-medium text-white">
      Rattacher la selection
    </button>
  </div>
</div>
